import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f9c39a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-multiselect-header" }
const _hoisted_2 = { style: {"width":"100%","line-height":"100%"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('全て'))

import i18n from "@/locale/i18n";
import { MultiSelectChangeEvent } from "primevue/multiselect";
import { ref, onMounted, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'XMultiSelect',
  props: {
    modelValue: {
        type: Array<any>,
        default : [],
        require: true
    },
    optionLabel: {
        type: String,
        default: 'label'
    },
    optionValue: {
        type: null,
        default: 'value'
    },
    options: {
        type: Array<any>,
        require: true
    },
    value: {
        type: Array,
        default: () => {[]}
    },
    enableAllValue: {
        type: Boolean,
        default: false
    },
    enableCustomizePanleStyle: {
        type: Boolean,
        default: false
    }
},
  emits: ['update:modelValue', 'change', 'show', 'hide', 'click'],
  setup(__props, { emit: emits }) {

const props = __props

const t = i18n.global.t;
const isMouseClick = ref(false);


watch(() => props.modelValue, (newVal, oldVal)=> {
    modelValueTem.value = newVal;
    if (!modelValueTem.value) {
        modelValueTem.value = [];
    }
    if (props.options && modelValueTem.value.length && modelValueTem.value.length === props.options.length) {
        multiSelectAllSelected.value = 'YES';
    } else {
        multiSelectAllSelected.value = 'NO';
    }
}, {deep: true})


const updateValue = (newValue: []) => {
    emits('update:modelValue', newValue)
}

const multiSelectRef = ref();

const multiSelectAllSelected = ref('NO');

const optionValueProp = ref(props.optionValue);

const modelValueTem = ref(props.modelValue?props.modelValue:[]);

const displayPanle = ref(false);

const multiSelectIsHide = ref(false);

const multiSelectBoxChange = (value: any) => {
    if (value === 'YES') {
        let arrayTem: String[] = [];
        props.options!.forEach(item => {
            arrayTem.push(item[`${optionValueProp.value}`]);
        });
        modelValueTem.value = arrayTem;
        emits('update:modelValue', arrayTem);
    } else {
        modelValueTem.value = [];
        emits('update:modelValue', []);
    }
}

const multiSelectPanleClose = () => {
    multiSelectAllSelected.value = 'NO';

    modelValueTem.value = [];
    emits('update:modelValue', []);
    
    multiSelectRef.value.hide();

    console.log("multiSelectRef.value")
    console.log(multiSelectRef.value)
}

const multiSelectChange = (event: MultiSelectChangeEvent) => {
    console.log(props.options)
    console.log(event.value)
    if (modelValueTem.value!.length === props.options!.length) {
        multiSelectAllSelected.value = 'YES';
    } else {
        multiSelectAllSelected.value = 'NO';
    }

    modelValueTem.value = event.value;

    emits('update:modelValue', event.value);
    emits('change', event.value);

}

onMounted(() => {

    if (modelValueTem.value === undefined || modelValueTem.value === null) {
        modelValueTem.value = [];
    }

    if (props.options && modelValueTem.value.length && modelValueTem.value.length === props.options.length) {
        multiSelectAllSelected.value = 'YES';
    } else {
        multiSelectAllSelected.value = 'NO';
    }
})
const listenerKey = (event: any) => {
    if (!props.enableCustomizePanleStyle) {
        return;
    }
    if (event.code === 'ArrowDown') {
        event.preventDefault();
    }
    if (event.altKey && event.code === 'ArrowDown') {
        displayPanle.value = true;
        if (multiSelectIsHide.value) {
            // multiSelectRef.value.$el.click();
        }
    }
    if (event.code === 'Backspace' && !displayPanle.value && modelValueTem.value.length > 0) {
        modelValueTem.value = [];
        multiSelectAllSelected.value = 'NO';
        multiSelectChange({originalEvent: event, value: []});
    }
 }

 const mouseClick = (event: any) => {
    if (event.pointerType === 'mouse') {
        if (!displayPanle.value && multiSelectRef.value === document.activeElement) {
            multiSelectRef.value.$el.click();
        }
        isMouseClick.value = true;
    }
    emits('click', event);
}

 const multiSelectPanelHide = (event: any) => {
    displayPanle.value = false;
    multiSelectIsHide.value = true;
    isMouseClick.value = false;
    emits('hide', event);
 }

 const multiSelectPanelShow = (event: any) => {
    multiSelectIsHide.value = false;
    emits('show', event);
 }

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createBlock(_component_MultiSelect, {
    ref_key: "multiSelectRef",
    ref: multiSelectRef,
    modelValue: modelValueTem.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValueTem).value = $event)),
    panelClass: __props.enableCustomizePanleStyle && !displayPanle.value && !isMouseClick.value ? 'global-multi-select-panel' : '',
    options: __props.options,
    optionLabel: props.optionLabel,
    optionValue: props.optionValue,
    placeholder: _unref(t)('COMMON.MULTISELECT.PLACEHOLDER'),
    showToggleAll: false,
    onKeydown: listenerKey,
    onHide: multiSelectPanelHide,
    onShow: multiSelectPanelShow,
    class: "p-multiselect-label-container",
    filter: false,
    onChange: multiSelectChange,
    onClick: mouseClick
  }, _createSlots({
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Checkbox, {
          name: "tem",
          trueValue: "YES",
          falseValue: "NO",
          binary: true,
          modelValue: multiSelectAllSelected.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((multiSelectAllSelected).value = $event)),
          onInput: multiSelectBoxChange,
          "aria-checked": true
        }, null, 8, ["modelValue"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)("COMMON.MULTISELECT.FILTER")), 1),
        _createElementVNode("button", {
          class: "p-multiselect-close p-link",
          onClick: multiSelectPanleClose
        }, _hoisted_4)
      ])
    ]),
    _: 2
  }, [
    (__props.enableAllValue && modelValueTem.value.length && modelValueTem.value.length === __props.options?.length)
      ? {
          name: "value",
          fn: _withCtx(() => [
            _hoisted_5
          ])
        }
      : undefined
  ]), 1032, ["modelValue", "panelClass", "options", "optionLabel", "optionValue", "placeholder"]))
}
}

})